import React from 'react';
import { Button } from 'lib/ui';
import { WHITE, RED } from 'utils/constants/theme';
import { MileageFooterWrapper } from '../style';

interface Props {
  backToForm: () => void;
  message?: string;
}

const ConvertedWarningFooter: React.FC<Props> = ({
  backToForm,
  message
}: Props) => {
  return (
    <MileageFooterWrapper>
      <div
        style={{
          background: WHITE,
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          borderTop: '1px solid #d8d8d8',
          padding: '30px'
        }}
      >
        <h2 className="mileage-header" style={{ color: RED }}>
          Warning
        </h2>
        <p className="mileage-error">
          {message ||
            'This appointment has already been converted and can no longer be edited. Please go back to the form.'}
        </p>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button className="secondary" type="" onClick={backToForm}>
            Back To Form
          </Button>
        </div>
      </div>
    </MileageFooterWrapper>
  );
};
export default React.memo(ConvertedWarningFooter);
